import { createLogic } from 'redux-logic';
import {
  ERROR_VERIFY_SMS_ACTIVATION_CODE,
  ERROR_SEND_SMS_ACTIVATION_CODE,
  ERROR_SUBMIT_SMS_ACTIVATION
} from 'state/alertsAndNotifications/AlertsAndNotificationsActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';

const FailedSMSActivationCodeLogic = createLogic({
  type: [
    ERROR_VERIFY_SMS_ACTIVATION_CODE,
    ERROR_SEND_SMS_ACTIVATION_CODE,
    ERROR_SUBMIT_SMS_ACTIVATION
  ],

  process({ action }, dispatch, done) {
    // dispatch analytics message
    dispatch(analyticsActionError(action.type));

    done();
  }
});

export default FailedSMSActivationCodeLogic;
